<script>
export default {
  $_veeValidate: {
    name() {
      return this.name || this.label;
    },
    value() {
      return this.value;
    }
  },

  props: {
    value: [String, Number],
    label: String,
    name: { type: String, required: false, default: null },
    error: { type: String, required: false },
    disabled: { type: Boolean, required: false, default: false },
    loading: { type: Boolean, required: false, default: false }
  },

  computed: {
    isActive() {
      return !!this.value;
    }
  }
};
</script>

<template>
  <div class="group" :class="{'with-error': error && !disabled}" :loading="loading">
    <div v-if="error && !disabled" class="error">{{error}}</div>

    <select
      :value="value"
      :disabled="disabled || loading"
      @input="$emit('input', $event.target.value)"
    >
      <slot />
    </select>

    <label :active="isActive">{{label}}</label>
  </div>
</template>

<style lang="scss" scoped>
.group {
  display: flex;
  height: 45px;
  margin-top: 8px;
  flex-flow: column-reverse;
  flex-grow: 1;

  select {
    flex: 1;
    margin: 0 5px;
    z-index: 1;
    background-color: transparent;
    padding-left: 0px;
    border: none;
    transition: all 0.5s ease;
    min-height: 25px;
    border-bottom: 1px solid #b8b8b8;
    font-weight: 400;
    color: #333;

    &::placeholder {
      opacity: 0;
    }

    &:focus {
      border-bottom: 2px solid var(--purple);
      + label {
        color: var(--purple);
      }
    }

    &[disabled],
    &[disabled]:focus + label,
    &[disabled]:not(:placeholder-shown) + label {
      opacity: 0.3;
      cursor: default;
    }

    option[value="0"] {
      display: none;
    }
  }

  label {
    margin-left: 6px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 400;
    transition: all 0.25s ease;
    cursor: text;
    transform-origin: left bottom;
    transform: translateY(20px) scale(1);
    user-select: none;

    &[active="true"] {
      transform-origin: left bottom;
      transform: translateY(0px) scale(0.85);
    }
  }

  &[loading="true"]::after {
    content: "";
    position: relative;
    top: 35px;
    left: calc(100% - 35px);
    display: block;
    width: 12px;
    min-height: 12px;
    border-radius: 24px;
    background-clip: padding-box;
    border: rgba(black, 0.3) 2px solid;
    border-top-color: #fff;
    animation: animation-rotate 750ms linear infinite;
  }

  &.with-error {
    height: 60px;

    label {
      color: $pink;
    }

    select {
      border-bottom: 1px solid $pink;
      color: $pink !important;

      &:focus {
        border-bottom: 2px solid $pink;
        + label {
          color: $pink;
        }
      }
    }
  }

  .error {
    font-size: 11px;
    color: $pink;
    padding-left: 5px;
    padding-top: 3px;
    height: 15px;
  }
}

@keyframes animation-rotate {
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_base/Select.vue